export default {
  CREATING: 'ADMIN_VIEW_MARKET_GROUPS_CREATOR_CREATING',
  CREATED: 'ADMIN_VIEW_MARKET_GROUPS_CREATOR_CREATED',
};
